// AUTO-GENERATED by scripts/sync-permissions.cjs. Do not edit manually.

export const PERMISSION_KEYS = Object.freeze([
  'admin:users:manage',
  'audit:read',
  'auth:pending_users',
  'auth:user_last_login',
  'auth:user_permission_grants',
  'auth:user_role_assignments',
  'catalog:create',
  'catalog:deactivate',
  'catalog:read',
  'catalog:refresh',
  'catalog:update',
  'cleaner:create',
  'cleaner:deactivate',
  'cleaner:read',
  'cleaner:token:rotate',
  'cleaner:update',
  'contractor:approve',
  'contractor:create',
  'contractor:delete',
  'contractor:read',
  'contractor:update',
  'customer:create',
  'customer:read',
  'customer:update',
  'estimate:create',
  'estimate:delete',
  'estimate:read',
  'estimate:send',
  'estimate:update',
  'invoice:read',
  'invoice:update',
  'item:read',
  'overtime:request',
  'overtime:review',
  'overtime:settle',
  'project_namer:manage',
  'project_namer:read',
  'project_starter:manage',
  'request:approve',
  'request:create',
  'request:delete',
  'request:read',
  'request:reject',
  'settings:notifications:manage',
  'vendor:create',
  'vendor:delete',
  'vendor:read',
  'vendor:update',
])

export const PERMISSIONS = Object.freeze({
  ADMIN_USERS_MANAGE: 'admin:users:manage',
  AUDIT_READ: 'audit:read',
  AUTH_PENDING_USERS: 'auth:pending_users',
  AUTH_USER_LAST_LOGIN: 'auth:user_last_login',
  AUTH_USER_PERMISSION_GRANTS: 'auth:user_permission_grants',
  AUTH_USER_ROLE_ASSIGNMENTS: 'auth:user_role_assignments',
  CATALOG_CREATE: 'catalog:create',
  CATALOG_DEACTIVATE: 'catalog:deactivate',
  CATALOG_READ: 'catalog:read',
  CATALOG_REFRESH: 'catalog:refresh',
  CATALOG_UPDATE: 'catalog:update',
  CLEANER_CREATE: 'cleaner:create',
  CLEANER_DEACTIVATE: 'cleaner:deactivate',
  CLEANER_READ: 'cleaner:read',
  CLEANER_TOKEN_ROTATE: 'cleaner:token:rotate',
  CLEANER_UPDATE: 'cleaner:update',
  CONTRACTOR_APPROVE: 'contractor:approve',
  CONTRACTOR_CREATE: 'contractor:create',
  CONTRACTOR_DELETE: 'contractor:delete',
  CONTRACTOR_READ: 'contractor:read',
  CONTRACTOR_UPDATE: 'contractor:update',
  CUSTOMER_CREATE: 'customer:create',
  CUSTOMER_READ: 'customer:read',
  CUSTOMER_UPDATE: 'customer:update',
  ESTIMATE_CREATE: 'estimate:create',
  ESTIMATE_DELETE: 'estimate:delete',
  ESTIMATE_READ: 'estimate:read',
  ESTIMATE_SEND: 'estimate:send',
  ESTIMATE_UPDATE: 'estimate:update',
  INVOICE_READ: 'invoice:read',
  INVOICE_UPDATE: 'invoice:update',
  ITEM_READ: 'item:read',
  OVERTIME_REQUEST: 'overtime:request',
  OVERTIME_REVIEW: 'overtime:review',
  OVERTIME_SETTLE: 'overtime:settle',
  PROJECT_NAMER_MANAGE: 'project_namer:manage',
  PROJECT_NAMER_READ: 'project_namer:read',
  PROJECT_STARTER_MANAGE: 'project_starter:manage',
  REQUEST_APPROVE: 'request:approve',
  REQUEST_CREATE: 'request:create',
  REQUEST_DELETE: 'request:delete',
  REQUEST_READ: 'request:read',
  REQUEST_REJECT: 'request:reject',
  SETTINGS_NOTIFICATIONS_MANAGE: 'settings:notifications:manage',
  VENDOR_CREATE: 'vendor:create',
  VENDOR_DELETE: 'vendor:delete',
  VENDOR_READ: 'vendor:read',
  VENDOR_UPDATE: 'vendor:update',
})
